import SettingsAccountModule from './settings-account.module'

export default SettingsAccountModule
